import axios from 'axios';
import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  sendTest() {
    return axios.post(`${this.url}/test`);
  }
}

export default new NotificationSubscriptions();
